<div class="microphone-bar">
  @for (microphone of microphones; track microphone) {
    <app-microphone
      [microphone]="microphone"
      [showText]="true"
      matTooltip="{{ 'pages.speech-service.microphone.mute_button' | transloco }}"
      >
    </app-microphone>
  }
</div>
